import currency from "currency.js";

import { getSelectedServicesPrice } from "@/features/flights/utils/additionalServices";
import type {
  GetFlightAvailabilityTokenOutputDataV2,
  GetFlightUpsellOptionItemDto,
  ValidateFlightPromoCodeOutputData,
} from "@/types/codegen";

export const getFlightOrderPrices = (
  flightDetails: GetFlightAvailabilityTokenOutputDataV2,
  selectedFare: GetFlightUpsellOptionItemDto | null,
  promoCodeData?: ValidateFlightPromoCodeOutputData,
) => {
  const basePrice = flightDetails?.totalPrice || 0;
  const servicesPrice = getSelectedServicesPrice(flightDetails);
  const farePrice = selectedFare?.totalPrice || 0;
  const baseTicketPrice = currency(basePrice)
    .subtract(servicesPrice)
    .subtract(farePrice).value;
  const totalPrice = promoCodeData?.paymentAmount || basePrice;
  const promoCodeDiscountAmount = promoCodeData?.discountAmount;

  return {
    basePrice,
    servicesPrice,
    farePrice,
    baseTicketPrice,
    totalPrice,
    promoCodeDiscountAmount,
  };
};
